import base_url from "./baseUrl";
import { getUserToken } from "./util";
import { config } from "./config";

// ✅ Main serverRequest (JSON only, with timeout)
export let serverRequest = (type, param, data, otpRequired = false, otp = null) => {
  let URL = base_url;
  let requestCompleted = false;

  return new Promise((resolve, reject) => {
    // Add timeout to prevent infinite loading - using config timeout
    const timeoutId = setTimeout(() => {
      if (!requestCompleted) {
        requestCompleted = true;
  // Only reject, let consumer handle notification
        reject(new Error("Request timeout"));
      }
    }, config.api.timeout);

    fetch(URL + param, {
      method: type,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getUserToken()}`,
        "Accept": "application/json",
        "otp": otpRequired ? otp : null,
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        if (requestCompleted) return;
        clearTimeout(timeoutId);
        let resp;
        try {
          resp = await response.json();
        } catch (e) {
          resp = null;
        }
        if (!response.ok) {
          // Prefer backend message if present
          if (resp && resp.message) {
            throw new Error(resp.message);
          } else {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
        }
        return resp;
      })
      .then((resp) => {
        if (requestCompleted) return;
        requestCompleted = true;
        if (resp && resp.success) {
          resolve(resp);
        } else {
          // Prefer backend message if present
          reject(resp && resp.message ? new Error(resp.message) : resp || new Error("Unknown error"));
        }
      })
      .catch((error) => {
        if (requestCompleted) return;
        requestCompleted = true;
        clearTimeout(timeoutId);
        reject(error);
      })
      .finally(() => {
        if (!requestCompleted) {
          requestCompleted = true;
          clearTimeout(timeoutId);
        }
      });
  });
};

// ✅ NEW: FormData request handler (file upload only)
export const serverFormRequest = (type, param, formData, otpRequired = false, otp = null) => {
  let URL = base_url;
  let requestCompleted = false;

  return new Promise((resolve, reject) => {
    fetch(URL + param, {
      method: type,
      headers: {
        "Authorization": `Bearer ${getUserToken()}`,
        "Accept": "application/json",
        ...(otpRequired ? { otp } : {})
        // ⚠️ No Content-Type, browser handles it for FormData
      },
      body: formData,
    })
      .then(async (response) => {
        if (requestCompleted) return;
        let resp;
        try {
          resp = await response.json();
        } catch (e) {
          resp = null;
        }
        if (!response.ok) {
          if (resp && resp.message) {
            throw new Error(resp.message);
          } else {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
        }
        return resp;
      })
      .then((resp) => {
        if (requestCompleted) return;
        requestCompleted = true;
        if (resp && resp.success) {
          resolve(resp);
        } else {
          reject(resp && resp.message ? new Error(resp.message) : resp || new Error("Unknown error"));
        }
      })
      .catch((error) => {
        if (requestCompleted) return;
        requestCompleted = true;
        reject(error);
      });
  });
};

// ✅ Unauthenticated JSON request handler (fixed)
export let serverRequestNoBearer = (type, param, data) => {
  let URL = base_url;
  let requestCompleted = false;

  return new Promise((resolve, reject) => {
    fetch(URL + param, {
      method: type,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        // No Authorization header for unauthenticated requests
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        if (requestCompleted) return;
        let resp;
        try {
          resp = await response.json();
        } catch (e) {
          resp = null;
        }
        if (!response.ok) {
          if (resp && resp.message) {
            throw new Error(resp.message);
          } else {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
        }
        return resp;
      })
      .then((resp) => {
        if (requestCompleted) return;
        requestCompleted = true;
        if (resp && resp.success) {
          resolve(resp);
        } else {
          reject(resp && resp.message ? new Error(resp.message) : resp || new Error("Unknown error"));
        }
      })
      .catch((error) => {
        if (requestCompleted) return;
        requestCompleted = true;
        reject(error);
      })
      .finally(() => {
        if (!requestCompleted) requestCompleted = true;
      });
  });
};
